var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "nav-top" }, [
      _c("div", { staticClass: "box" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.nowTime))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clear" }),
    _vm._v(" "),
    _c("div", { staticClass: "search-box" }, [
      _c("div", { staticClass: "box relative" }, [
        _c("img", {
          staticClass: "absolute titleLogo",
          attrs: { src: require("../../assets/title_logo.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "search  absolute" }, [
          _c(
            "form",
            {
              attrs: {
                action: "",
                method: "post",
                name: "searchform",
                onSubmit: "return false"
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchContent,
                    expression: "searchContent"
                  }
                ],
                staticClass: "input_text",
                attrs: {
                  name: "keyboard",
                  autocomplete: "off",
                  placeholder: "",
                  type: "text"
                },
                domProps: { value: _vm.searchContent },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.showSearchPage($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchContent = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "searchBotton",
                attrs: {
                  src: require("../../assets/images/search.png"),
                  alt: ""
                },
                on: { click: _vm.showSearchPage }
              })
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "nav-box", staticStyle: { "margin-top": "48px" } },
      [
        _c("div", { staticClass: "box" }, [
          _c("ul", [
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 0 ? "active" : "",
                attrs: { index: 0 },
                on: {
                  click: function($event) {
                    return _vm.menClick(0)
                  }
                }
              },
              [_c("router-link", { attrs: { to: "/" } }, [_vm._v("首页")])],
              1
            ),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 1 ? "active" : "",
                attrs: { index: 1 },
                on: {
                  click: function($event) {
                    return _vm.menClick(1)
                  }
                }
              },
              [
                _c("router-link", { attrs: { to: "/newIndex" } }, [
                  _vm._v("水保新闻")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {}),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "bulletin-board",
                class: { active: _vm.$route.meta.index == 2 },
                attrs: { index: 2 },
                on: {
                  click: function($event) {
                    return _vm.menClick(2)
                  },
                  mouseover: function($event) {
                    _vm.showSubMenu = true
                  },
                  mouseleave: function($event) {
                    _vm.showSubMenu = false
                  }
                }
              },
              [
                _c("router-link", { attrs: { to: "/noticeIndex" } }, [
                  _vm._v("公告栏")
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSubMenu,
                        expression: "showSubMenu"
                      }
                    ],
                    staticClass: "sub-menu"
                  },
                  [
                    _c(
                      "li",
                      [
                        _c("router-link", { attrs: { to: "/bulletinIndex" } }, [
                          _vm._v("水保公报")
                        ])
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 5 ? "active" : "",
                attrs: { index: 5 },
                on: {
                  click: function($event) {
                    return _vm.menClick(5)
                  }
                }
              },
              [
                _c("router-link", { attrs: { to: "/monitoringIndex" } }, [
                  _vm._v("监督监测")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 4 ? "active" : "",
                attrs: { index: 4 },
                on: {
                  click: function($event) {
                    return _vm.menClick(4)
                  }
                }
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/comprehensiveControlIndex" } },
                  [_vm._v("综合治理")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 9 ? "active" : "",
                attrs: { index: 7 },
                on: {
                  click: function($event) {
                    return _vm.menClick(9)
                  }
                }
              },
              [
                _c("router-link", { attrs: { to: "/creditManagementIndex" } }, [
                  _vm._v("信用管理")
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div"),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.$route.meta.index == 6 ? "active" : "",
                attrs: { index: 6 },
                on: {
                  click: function($event) {
                    return _vm.menClick(6)
                  }
                }
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/policiesAndRegulationsIndex" } },
                  [_vm._v("政策法规")]
                )
              ],
              1
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", { staticClass: "el-icon-s-custom" }),
      _vm._v(" 欢迎来到河南省水土保持！")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3107d088", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3107d088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Header.vue
// module id = null
// module chunks = 